import { types } from './types';

const INITIAL_STATE = {
  username: "",
  password: "",
  confirmPassword: "",
  rememberMe: false,
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.GET_USER.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.UPDATE_USER.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.RESET_USER:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    default:
    return state;
  }
};

export default reducer;
